var Board = require("./linedash.js");

var View = function($el) {
  this.$el = $el;
  this.board = new Board(50);
  this.setupBoard(this.board.boardSize);
  this.renderBoard();
  this.showControls();

  this.lost = false;
  this.started = false;
  this.counter = 0;
  this.obstacleInterval = 9;

  $(window).on("keydown", this.handleKeyEvent.bind(this));
}

View.prototype.setupBoard = function(boardSize) {
  var $ul = $("<ul>");

  for (var i = 0; i < boardSize; i++) {
    for (var j = 0; j < boardSize; j++) {
      var $li = $("<li>");
      $li.attr("pos", [i, j]);
      if (i < 21 || i > 29) {
        $li.addClass("wall");
      }
      $ul.append($li);
    }
  };

  this.$el.append($ul);

  for (var i = 0; i < this.board.walls.length; i++) {
    var $wall = $("[pos='" + this.board.walls[i] + "']");
    $wall.addClass("wall");
  };

  var $center = $("[pos='" + [this.board.middle, this.board.middle] + "']");
  var $counter = $("<span>");
  $counter.addClass("counter");
  $center.append($counter);
};

View.prototype.renderBoard = function() {
  var $obstacles = $(".obstacle");
  $obstacles.removeAttr("class");

  var $oldDasher = $(".dasher");
  $oldDasher.removeAttr("class");

  for (var i = 0; i < this.board.line.length; i++) {
    var $line = $("[pos='" + this.board.line[i] + "']");
    $line.addClass("line");
  }

  for (var i = 0; i < this.board.obstacles.length; i++) {
    var $obstacle = $("[pos='" + this.board.obstacles[i] + "']");
    $obstacle.addClass("obstacle");
  }

  var $dasher = $("[pos='" + this.board.dasher + "']");
  $dasher.addClass("dasher");

  var $counter = $(".counter");
  $counter.text(this.counter);
};

View.prototype.startMusic = function () {
  var music = "<embed src='./music/Hindsight.mp3' autostart='true' loop='true' hidden='true'>";
  var musicElement = $(music);
  this.$el.append(musicElement);
};

View.prototype.stopMusic = function () {
  var $musicElement = $("embed");
  $musicElement.remove();
};

View.prototype.playGameOverSound = function () {
  var sound = "<embed src='./music/gameover.mp3' autostart='true' hidden='true'>";
  var soundElement = $(sound);
  this.$el.append(soundElement);
};

View.prototype.showControls = function () {
  var $div = $("<div>");
  $div.html("<h1>Linedash</h1>Enter: start/restart<br/>Spacebar: change sides");
  this.$el.append($div);
};

View.prototype.step = function() {
  if (this.counter % this.obstacleInterval === 0) {
    this.board.createObstacle();
  }

  this.counter += 1;
  this.board.move();
  this.renderBoard();

  if (this.board.collision()) {
    this.gameover();
  }
};

View.prototype.gameover = function() {
  this.lost = true;
  this.showControls();
  this.stopMusic();

  // this.playGameOverSound();

  clearInterval(this.gameFrames);

  var $ul = $("ul");
  $ul.addClass("pause");
};

View.prototype.handleKeyEvent = function(e) {
  if (!this.started && e.keyCode === 13) {
    this.gameFrames = setInterval(this.step.bind(this), 35);
    this.startMusic();
    this.started = true;

    $("div").remove();
    var $ul = $("ul");
    $ul.addClass("rotate");
  } else if (this.started && e.keyCode === 32) {
    this.board.changeSides();
  } else if (this.lost && e.keyCode === 13) {
    location.reload();
  }
};

module.exports = View;



/*****************
 ** WEBPACK FOOTER
 ** ./js/linedash-view.js
 ** module id = 1
 ** module chunks = 0
 **/